import { render, staticRenderFns } from "./PlantList.vue?vue&type=template&id=fa1e007c&scoped=true&"
import script from "./PlantList.vue?vue&type=script&lang=js&"
export * from "./PlantList.vue?vue&type=script&lang=js&"
import style0 from "./PlantList.vue?vue&type=style&index=0&id=fa1e007c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1e007c",
  null
  
)

export default component.exports